import React, { useState } from 'react';
import { Modal, Spinner } from 'react-bootstrap';
import API from '../../../api/axiosInstance';

const OnsiteSignatureModal = ({ show, onHide, participant, onCleared }) => {
  const [clearing,     setClearing]     = useState(false);
  const [confirmClear, setConfirmClear] = useState(false);
  const [error,        setError]        = useState('');

  const handleHide = () => {
    setConfirmClear(false);
    setError('');
    onHide();
  };

  const handleConfirm = async () => {
    setClearing(true);
    setError('');
    try {
      await API.patch(`/ems/onsite/participants/${participant._id}/clear-signature`);
      onCleared(participant._id);
      handleHide();
    } catch (err) {
      setError(err.response?.data?.message || err.message);
    } finally {
      setClearing(false);
    }
  };

  const firstName = participant?.person_data?.givenFirstName || participant?.person_id?.name || '';
  const lastName  = participant?.person_data?.familyLastName  || participant?.person_id?.lname || '';
  const sigUrl    = participant?.person_data?.signatureDataUrl;

  return (
    <Modal show={show} onHide={handleHide} centered size="md">
      <Modal.Header closeButton style={{ borderBottom: '1px solid #f0ece3' }}>
        <Modal.Title style={{ fontSize: '16px', fontFamily: '"Poppins", sans-serif', fontWeight: 600 }}>
          Signature — {firstName} {lastName}
        </Modal.Title>
      </Modal.Header>

      <Modal.Body style={{ padding: '24px' }}>
        <div style={{ border: '1.5px dashed #d4cfc4', borderRadius: '12px', background: '#fcfbf9', padding: '12px', marginBottom: '20px', minHeight: '120px', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
          {sigUrl
            ? <img src={sigUrl} alt="Signature" style={{ maxWidth: '100%', maxHeight: '160px' }} />
            : <span style={{ color: '#c8c4ba', fontSize: '14px' }}>No signature on file</span>
          }
        </div>

        {error && (
          <div style={{ color: '#b32424', fontSize: '13px', marginBottom: '12px' }}>
            <i className="fa-solid fa-triangle-exclamation" style={{ marginRight: '6px' }} />{error}
          </div>
        )}

        {!confirmClear ? (
          <div style={{ display: 'flex', justifyContent: 'flex-end' }}>
            <button
              onClick={() => setConfirmClear(true)}
              disabled={!sigUrl}
              style={{ background: 'none', border: '1px solid #d9534f', borderRadius: '8px', padding: '7px 18px', fontSize: '13px', color: '#d9534f', cursor: sigUrl ? 'pointer' : 'not-allowed', opacity: sigUrl ? 1 : 0.4, fontFamily: '"Poppins", sans-serif' }}
            >
              <i className="fa-solid fa-eraser" style={{ marginRight: '6px' }} />Clear Signature
            </button>
          </div>
        ) : (
          <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', background: '#fff5f5', border: '1px solid #f5c6cb', borderRadius: '8px', padding: '10px 14px' }}>
            <span style={{ fontSize: '13px', color: '#721c24', fontFamily: '"Poppins", sans-serif' }}>Are you sure? This cannot be undone.</span>
            <div style={{ display: 'flex', gap: '8px' }}>
              <button
                onClick={() => setConfirmClear(false)}
                disabled={clearing}
                style={{ background: 'none', border: '1px solid #ccc', borderRadius: '6px', padding: '5px 14px', fontSize: '12px', cursor: 'pointer', fontFamily: '"Poppins", sans-serif' }}
              >
                Cancel
              </button>
              <button
                onClick={handleConfirm}
                disabled={clearing}
                style={{ background: '#d9534f', border: 'none', borderRadius: '6px', padding: '5px 14px', fontSize: '12px', color: '#fff', cursor: clearing ? 'not-allowed' : 'pointer', fontFamily: '"Poppins", sans-serif' }}
              >
                {clearing ? <Spinner animation="border" size="sm" /> : 'Confirm'}
              </button>
            </div>
          </div>
        )}
      </Modal.Body>
    </Modal>
  );
};

export default OnsiteSignatureModal;
